import React from "react";
import { useTranslation } from "react-i18next";
import { getCountryCode } from "../../../../../utils/Internationalization/handleAppInternationalization";

const BPlusBenefitPoints = ({cname}) => {
    const { t } = useTranslation(["translation"]);
    const classNames = (cname) ? cname.split(',').join('') : '';
    const countryCode = getCountryCode();
    return (
        <ul className= {`${classNames}`}>
            {(countryCode !== 'SE') ? <li>{t("BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.BENEFIT_POINTS.POINT_1")}</li> : null}
            <li>{t("BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.BENEFIT_POINTS.POINT_2")}</li>
            <li>{t("BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.BENEFIT_POINTS.POINT_3")}</li>
            <li>{t("BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.BENEFIT_POINTS.POINT_4")}</li>
            <li>{t("BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.BENEFIT_POINTS.POINT_5")}</li>
            <li>{t("BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.BENEFIT_POINTS.POINT_6")}</li>
        </ul>
    )
}

export default BPlusBenefitPoints;